function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u5BFC\\u822A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u4F53\\u9A8C\\u8BBE\\u8BA1\\u89C4\\u8303WEB-V2.2.2",
  transform: "translate(-968.000000, -5796.000000)",
  fill: "#D7D7D7"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-5",
  transform: "translate(314.000000, 5781.000000)"
}, React.createElement("path", {
  d: "M662,15 C666.418278,15 670,18.581722 670,23 C670,27.418278 666.418278,31 662,31 C657.581722,31 654,27.418278 654,23 C654,18.581722 657.581722,15 662,15 Z M662.816186,26.4 L661.220917,26.4 L661.220917,27.9626031 L662.816186,27.9626031 L662.816186,26.4 Z M662.06,18.3663322 C661.64,18.3663322 661.28,18.4263322 660.92,18.5463322 C660.5,18.6663322 660.2,18.8463322 659.9,19.1463322 C659.6,19.3863322 659.36,19.6863322 659.24,19.9863322 C659.12,20.2863322 659,20.7663322 659,21.3663322 L660.2,21.3663322 C660.2,20.1663322 660.8,19.3263322 662,19.3263322 C662.54,19.3263322 662.96,19.5063322 663.26,19.8063322 C663.56,20.1063322 663.74,20.4063322 663.74,20.8263322 C663.74,21.2463322 663.62,21.5463322 663.5,21.7263322 C663.38,21.9063322 663.08,22.2063322 662.66,22.6263322 C662.24,23.0463322 662.06,23.3463322 661.88,23.5863322 C661.7,23.8263322 661.58,24.0663322 661.52,24.3663322 C661.46,24.6663322 661.4,24.9663322 661.4,25.5663322 L662.6,25.5663322 C662.6,25.2682242 662.536652,25.0329154 662.66,24.5463322 C662.783348,24.0597491 663.38,23.4063322 663.86,22.9863322 C664.34,22.5663322 664.64,22.2063322 664.76,21.9063322 C664.88,21.6063322 665,21.3063322 665,20.9463322 C665,20.1663322 664.7,19.5663322 664.16,19.0863322 C663.56,18.6063322 662.9,18.3663322 662.06,18.3663322 Z",
  id: "\\u5F62\\u72B6\\u5907\\u4EFD-48"
}))));

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.75d6fbd7.svg";
export { ForwardRef as ReactComponent };